import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { placeholder } from 'src/app/models/placeholder';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'primary-list-card',
  templateUrl: './primary-list-card.component.html',
  styleUrls: ['./primary-list-card.component.scss'],
})
export class PrimaryListCardComponent implements OnInit {
  @Input() itemInfo: any;
  @Input() selectedLocation: any;
  @Output() performAction = new EventEmitter<any>();

  public imagePlaceholder: string = placeholder;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {}
  navigateFunction(item) {
    this.performAction.emit(item);
    this.analyticsService.trackUnified('book_now_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'retail-list-card',
      button: 'book-now-button',
    });
  }
}
